import { render, staticRenderFns } from "./customer-data.vue?vue&type=template&id=a991d034&scoped=true&"
import script from "./customer-data.vue?vue&type=script&lang=js&"
export * from "./customer-data.vue?vue&type=script&lang=js&"
import style0 from "./customer-data.vue?vue&type=style&index=0&id=a991d034&scoped=true&lang=css&"
import style1 from "./customer-data.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991d034",
  null
  
)

export default component.exports